import { Product, Order, User } from './types'

export const categories = ['All', 'Electronics', 'Clothing', 'Home & Kitchen', 'Books', 'Sports']

export const products: Product[] = [
  {
    id: 1,
    name: 'Samsung 4K Smart TV 55"',
    title: 'Samsung 4K Smart TV 55"',
    sku: 'TV-001',
    category: 'Electronics',
    price: 89999,
    stock: 12,
    description: 'Crystal clear 4K UHD display with smart TV capabilities. Features HDR support, built-in streaming apps, and voice control.',
    image: 'https://images.unsplash.com/photo-1593359677879-a4bb92f829d1?w=400&h=300&fit=crop',
    rating: 4.5,
    active: true,
    featured: false,
    status: 'active',
  },
  {
    id: 2,
    name: 'Apple iPhone 15 Pro',
    title: 'Apple iPhone 15 Pro',
    sku: 'PHONE-001',
    category: 'Electronics',
    price: 159999,
    stock: 8,
    description: 'The most powerful iPhone ever with A17 Pro chip, titanium design, and revolutionary camera system.',
    image: 'https://images.unsplash.com/photo-1696446701796-da61225697cc?w=400&h=300&fit=crop',
    rating: 4.8,
    active: true,
    featured: true,
    status: 'active',
  },
  {
    id: 3,
    name: 'Nike Air Max 270',
    title: 'Nike Air Max 270',
    sku: 'SHOE-001',
    category: 'Clothing',
    price: 12999,
    stock: 35,
    description: 'Iconic sneaker with the largest heel Air unit yet. Lightweight and breathable for all-day comfort.',
    image: 'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=300&fit=crop',
    rating: 4.3,
    active: true,
    featured: false,
    status: 'active',
  },
  {
    id: 4,
    name: 'KitchenAid Stand Mixer',
    title: 'KitchenAid Stand Mixer',
    sku: 'KITCHEN-001',
    category: 'Home & Kitchen',
    price: 45000,
    stock: 6,
    description: 'Professional 5-quart stand mixer with 10 speeds. Perfect for baking enthusiasts and home chefs.',
    image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=400&h=300&fit=crop',
    rating: 4.7,
    active: true,
    featured: false,
    status: 'active',
  },
  {
    id: 5,
    name: 'Sony WH-1000XM5 Headphones',
    title: 'Sony WH-1000XM5 Headphones',
    sku: 'AUDIO-001',
    category: 'Electronics',
    price: 34999,
    stock: 20,
    description: 'Industry-leading noise canceling headphones with 30-hour battery life and multipoint connection.',
    image: 'https://images.unsplash.com/photo-1505740420928-5e560c06d30e?w=400&h=300&fit=crop',
    rating: 4.9,
    active: true,
    featured: true,
    status: 'active',
  },
  {
    id: 6,
    name: 'Levi\'s 501 Original Jeans',
    title: 'Levi\'s 501 Original Jeans',
    sku: 'JEANS-001',
    category: 'Clothing',
    price: 6500,
    stock: 50,
    description: 'The original jeans. Straight fit with button fly. Made from 100% cotton denim.',
    image: 'https://images.unsplash.com/photo-1542272454315-4c01d7abdf4a?w=400&h=300&fit=crop',
    rating: 4.2,
    active: true,
    featured: false,
    status: 'active',
  },
  {
    id: 7,
    name: 'Atomic Habits - James Clear',
    title: 'Atomic Habits - James Clear',
    sku: 'BOOK-001',
    category: 'Books',
    price: 1800,
    stock: 100,
    description: 'The #1 New York Times bestseller. Tiny changes, remarkable results. A proven framework for habit formation.',
    image: 'https://images.unsplash.com/photo-1589829085413-56de8ae18c73?w=400&h=300&fit=crop',
    rating: 4.9,
    active: true,
    featured: false,
    status: 'active',
  },
  {
    id: 8,
    name: 'Yoga Mat Pro',
    title: 'Yoga Mat Pro',
    sku: 'SPORTS-001',
    category: 'Sports',
    price: 3500,
    stock: 45,
    description: 'Premium non-slip yoga mat with alignment lines. 6mm thick for joint support. Eco-friendly material.',
    image: 'https://images.unsplash.com/photo-1601925260368-ae2f83cf8b7f?w=400&h=300&fit=crop',
    rating: 4.4,
    active: true,
    featured: false,
    status: 'active',
  },
  {
    id: 9,
    name: 'MacBook Air M2',
    title: 'MacBook Air M2',
    sku: 'LAPTOP-001',
    category: 'Electronics',
    price: 149999,
    stock: 5,
    description: 'Supercharged by M2 chip. Strikingly thin design with 18-hour battery life and stunning Liquid Retina display.',
    image: 'https://images.unsplash.com/photo-1611186871525-4c7f31a10ac6?w=400&h=300&fit=crop',
    rating: 4.8,
    active: true,
    featured: true,
    status: 'low_stock',
  },
  {
    id: 10,
    name: 'Dyson V15 Vacuum',
    title: 'Dyson V15 Vacuum',
    sku: 'VACUUM-001',
    category: 'Home & Kitchen',
    price: 55000,
    stock: 9,
    description: 'Laser detects microscopic dust. Automatically optimizes suction and run time. 60 minutes run time.',
    image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop',
    rating: 4.6,
    active: true,
    featured: false,
    status: 'active',
  },
  {
    id: 11,
    name: 'Adidas Ultraboost 23',
    title: 'Adidas Ultraboost 23',
    sku: 'SHOES-002',
    category: 'Sports',
    price: 15000,
    stock: 28,
    description: 'Energy-returning Boost midsole. Designed with Primeknit upper for a sock-like fit. Perfect for running.',
    image: 'https://images.unsplash.com/photo-1595950653106-6c9ebd614d3a?w=400&h=300&fit=crop',
    rating: 4.5,
    active: true,
    featured: false,
    status: 'active',
  },
  {
    id: 12,
    name: 'Nespresso Vertuo Coffee Maker',
    title: 'Nespresso Vertuo Coffee Maker',
    sku: 'COFFEE-001',
    category: 'Home & Kitchen',
    price: 18500,
    stock: 15,
    description: 'One-touch brewing. Recognizes each capsule and adjusts settings automatically. 5 cup sizes.',
    image: 'https://images.unsplash.com/photo-1574914629385-46b5fb7c9842?w=400&h=300&fit=crop',
    rating: 4.4,
    active: true,
    featured: false,
    status: 'active',
  },
]

export const orders: Order[] = [
  {
    id: 1,
    user_id: 1,
    product_id: 1,
    quantity: 1,
    total_price: 89999,
    status: 'delivered',
    payment_status: 'completed',
    created_at: '2026-02-10T00:00:00.000000Z',
    updated_at: '2026-02-10T00:00:00.000000Z',
    product: products[0],
  },
  {
    id: 2,
    user_id: 2,
    product_id: 3,
    quantity: 2,
    total_price: 25998,
    status: 'processing',
    payment_status: 'completed',
    created_at: '2026-02-14T00:00:00.000000Z',
    updated_at: '2026-02-14T00:00:00.000000Z',
    product: products[2],
  },
  {
    id: 3,
    user_id: 3,
    product_id: 9,
    quantity: 1,
    total_price: 149999,
    status: 'shipped',
    payment_status: 'completed',
    created_at: '2026-02-18T00:00:00.000000Z',
    updated_at: '2026-02-18T00:00:00.000000Z',
    product: products[8],
  },
  {
    id: 4,
    user_id: 5,
    product_id: 7,
    quantity: 3,
    total_price: 5400,
    status: 'pending',
    payment_status: 'pending',
    created_at: '2026-02-20T00:00:00.000000Z',
    updated_at: '2026-02-20T00:00:00.000000Z',
    product: products[6],
  },
  {
    id: 5,
    user_id: 1,
    product_id: 2,
    quantity: 1,
    total_price: 159999,
    status: 'cancelled',
    payment_status: 'cancelled',
    created_at: '2026-02-22T00:00:00.000000Z',
    updated_at: '2026-02-22T00:00:00.000000Z',
    product: products[1],
  },
]

export const users: User[] = [
  { id: 1, name: 'John Kamau', email: 'john@example.com', role: 'user', joined: '2025-11-01', active: true },
  { id: 2, name: 'Jane Wanjiku', email: 'jane@example.com', role: 'user', joined: '2025-12-15', active: true },
  { id: 3, name: 'Peter Odhiambo', email: 'peter@example.com', role: 'user', joined: '2026-01-03', active: false },
  { id: 4, name: 'Mary Njeri', email: 'mary@example.com', role: 'admin', joined: '2025-10-01', active: true },
  { id: 5, name: 'David Maina', email: 'david@example.com', role: 'user', joined: '2026-02-01', active: true },
]
